export function getAppConfigurations() {
  const {
    REACT_APP_ENVIRONMENT,
    REACT_APP_DATADOG_CLIENT_TOKEN,
    REACT_APP_DATADOG_APPLICATION_ID,
    REACT_APP_DATADOG_SERVICE,
    REACT_APP_API_URL,
    REACT_APP_VERSION,
    REACT_APP_MY_WISORY_URL,
  } = process.env;

  return {
    environment: REACT_APP_ENVIRONMENT || 'local',
    apiEndpoint: REACT_APP_API_URL || '',
    datadogService: REACT_APP_DATADOG_SERVICE,
    datadogClientToken: REACT_APP_DATADOG_CLIENT_TOKEN,
    datadogApplicationId: REACT_APP_DATADOG_APPLICATION_ID,
    myWisoryUrl: REACT_APP_MY_WISORY_URL,
    appVersion: REACT_APP_VERSION || 'local',
  };
}
